import { css } from 'styled-components';

const chanelTheme = {
    StockInfoContainer: css`
        display: flex;
        flex-direction: column;
        gap: ${({ theme }) => theme.Spacing16};
        border: 0;
        border-radius: 0;
        width: fit-content;
    `,
    StockInfoItemContainer: css`
        padding: 0;

        & + & {
            border-top: 0;
        }
    `,
    ChevronIcon: css`
        display: none;
    `
};

export default chanelTheme;
